module.exports = __webpack_public_path__ + "img/recording.3cc847df.gif";